import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';

export interface InputGroupChild {
  childName: string;
  radioGroupControlName?: string;
  selectedChildUnit?: any;
  childFormControlNameRate?: string;
  childFormControlNameFixed?: string;
}

@Component({
  selector: 'app-commission-input-group',
  templateUrl: './commission-input-group.component.html',
  styleUrls: ['./commission-input-group.component.scss']
})
export class CommissionInputGroupComponent implements OnInit {
  @Input() lang: string;
  @Input() units: Array<object>;
  @Input() form: FormGroup;
  @Input() fieldName: string;
  @Input() selectedUnit: any;
  @Input() formControlNameRate: any;
  @Input() formControlNameFixed: any;
  @Input() checkboxControlName: any;
  @Input() children: Array<InputGroupChild>;

  @Output() inputTotalChange = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  inputChange() {
    this.inputTotalChange.emit()
  }

}
